import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import { toSnakeCase } from 'helpers/utilities';

import RadioGroup from '../common/RadioGroup';
import TextBox from 'components/ui/TextBox';
import IconButton from 'material-ui/IconButton';
import MediaQuery from 'react-responsive';
import { media } from 'helpers/MediaHelper';
import TrashIcon from 'assets/trash.png';

const StyledRadioUnderline = styled.div`
  display: flex;
  border-bottom: 2px solid ${colors.LIGHT_GREY};
  width: ${props => (props.expand ? '100%' : '50%')};
  ${media.mobile`
    flex-direction: column;
    width: 100%;
  `};
`;

const StyledTextBox = styled(TextBox)`
  width: 50%;
  height: 32px;
  ${media.mobile`
    width: 100%;
  `};
`;

const StyledAddNewService = styled.div`
  margin-top: 30px;
  color: ${colors.ULTRAMARINE_BLUE};
`;

const DeleteContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

const StyledImg = styled.img`
  height: 21px;
  ${media.mobile`
    height: 19px;
  `};
`;

const StyledServiceHeader = styled.div`
  margin-top: 16px;
`;

const AdditionalServices = ({ services, setFieldValue }) => {
  const [additionalServices, setAdditionalServices] = useState([]);

  useEffect(
    () => {
      if (services && services.other) {
        setAdditionalServices(services.other);
      }
    },
    [services]
  );

  const addNewService = () => {
    let newAdditionalServices = [
      ...additionalServices,
      {
        name: '',
        is_included: false,
      },
    ];
    setFieldValue('services.other', newAdditionalServices);
    setAdditionalServices(newAdditionalServices);
  };

  const removeNewService = index => {
    let newAdditionalServices = [...additionalServices];
    newAdditionalServices.splice(index, 1);
    setFieldValue('services.other', newAdditionalServices);
    setAdditionalServices(newAdditionalServices);
  };

  const changeCustomServiceName = (e, index) => {
    let additionalService = additionalServices[index];
    additionalService.name = e.target.value;
    setFieldValue('services.other', [...additionalServices]);
    setAdditionalServices([...additionalServices]);
  };

  const changeCustomServiceIsIncluded = (value, index) => {
    let additionalService = additionalServices[index];
    additionalService.is_included = value;
    setFieldValue('services.other', [...additionalServices]);
    setAdditionalServices([...additionalServices]);
  };

  return (
    <React.Fragment>
      {additionalServices.map((service, index) => {
        return (
          <div>
            <MediaQuery query="(min-device-width: 750px)">
              <StyledRadioUnderline expand={true}>
                <RadioGroup
                  name={`${toSnakeCase(service.name)}_is_included`}
                  index={index}
                  value={service.is_included}
                  onChange={value => changeCustomServiceIsIncluded(value, index)}
                >
                  <StyledTextBox
                    name={`${toSnakeCase(service.name)}_name`}
                    value={service.name}
                    onChange={e => changeCustomServiceName(e, index)}
                    placeholder={getTranslatedString(
                      'landlordPortal.rentRoll.renewals.enterServiceHere'
                    )}
                    size="large"
                  />
                </RadioGroup>
                <DeleteContainer>
                  <IconButton
                    style={{ paddingLeft: '20px' }}
                    onClick={e => removeNewService(index)}
                  >
                    <StyledImg alt="" src={TrashIcon} />
                  </IconButton>
                </DeleteContainer>
              </StyledRadioUnderline>
            </MediaQuery>

            <MediaQuery query="(max-device-width: 750px)">
              <StyledRadioUnderline expand={true}>
                {index === 0 && (
                  <StyledServiceHeader>
                    {getTranslatedString('landlordPortal.rentRoll.renewals.service')}
                  </StyledServiceHeader>
                )}
                <RadioGroup
                  name={`${toSnakeCase(service.name)}_is_included`}
                  index={index}
                  value={service.is_included}
                  onChange={value => changeCustomServiceIsIncluded(value, index)}
                >
                  <DeleteContainer>
                    <StyledTextBox
                      name={`${toSnakeCase(service.name)}_name`}
                      value={service.name}
                      onChange={e => changeCustomServiceName(e, index)}
                      placeholder={getTranslatedString(
                        'landlordPortal.rentRoll.renewals.enterServiceHere'
                      )}
                      size="large"
                    />

                    <IconButton
                      style={{ paddingRight: '2px', textAlign: 'right' }}
                      onClick={e => removeNewService(index)}
                    >
                      <StyledImg alt="" src={TrashIcon} />
                    </IconButton>
                  </DeleteContainer>
                </RadioGroup>
              </StyledRadioUnderline>
            </MediaQuery>
          </div>
        );
      })}
      <StyledAddNewService onClick={e => addNewService()}>
        {getTranslatedString('landlordPortal.rentRoll.renewals.addNewService')}
      </StyledAddNewService>
    </React.Fragment>
  );
};

export default AdditionalServices;
